import get from 'lodash/get';
import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => {
    return state[NAME];
};

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getSave = createSelector(getModel, (model) => model.save);

export const getIsSaving = createSelector(getSave, (save) => save.isSaving);

export const getDataSave = createSelector(getSave, (save) => save.data);

export const getErrorsSave = createSelector(getSave, (save) => save.errors);

export const getFetch = createSelector(getModel, (model) => model.fetch);

export const getIsFetching = createSelector(
    getFetch,
    (fetch) => fetch.isFetching,
);

export const getDataFetch = createSelector(
    getFetch,
    (fetch) => fetch.data || {},
);

export const getCountryCurrencyFromProfile = createSelector(
    getDataFetch,
    (data) => get(data, 'currency_company_locale', {}),
);

export const getErrorsFetch = createSelector(getFetch, (fetch) => fetch.errors);

export const getCurrentValues = createSelector(
    getModel,
    (model) => model.currentValues,
);

export const getTheme = createSelector(getModel, (model) => model.theme);

export const getIsFromSpain = createSelector(
    getDataFetch,
    (data) => data?.company?.country_name === 'España',
);

export const getIsFromMexico = createSelector(
    getDataFetch,
    (data) => data?.company?.country_name === 'México',
);

export const getPresetScope = createSelector(
    getDataFetch,
    (data) => data?.settings?.preset_scope_preference,
);
